// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Result_Wrapper__3kzf2","Marketing":"Result_Marketing__3AAg7","Game":"Result_Game__1PgmF","Active":"Result_Active__22WZP","Badge":"Result_Badge__1Vqfx"};